<template>
  <div class="credentials-settings">
    <div class="household-name-container">
      <div class="title">היי {{ householdName }}</div>
    </div>
    <div class="credentials-list-container">
      <credentials-list></credentials-list>
    </div>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import CredentialsList from '../../../../../base-components/credentials/credentials-list/CredentialsList.vue';
import Segment from '../../../../../Segment';

export default {
  name: 'CredentialsSettings',
  components: {
    CredentialsList,
  },
  async created() {
    this.startLoading(this.$options.name);
    await this.fetchCredentials();
    this.doneLoading(this.$options.name);
    Segment.trackUserGot('CredentialsSettingsEntered', {});
  },
  computed: {
    ...mapGetters('session', ['householdName']),
  },
  methods: {
    ...mapActions('loader', ['startLoading', 'doneLoading']),
    ...mapActions('credentials', ['fetchCredentials', 'createCredentials']),
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../scss/mixins';

  .credentials-settings {

    .household-name-container {
      @include responsive-padding;
      width: 100%;
      padding-top: 20px;
      padding-bottom: 20px;

      .title {
        @include white-page-frame-title;
      }
    }

    .credentials-list-container {
      display: flex;
      justify-content: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/navigation-pages/credentials-settings/CredentialsSettings.vue